import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from "connected-react-router";

import * as actions from "../../store/actions";
import './Login.scss';
import { FormattedMessage } from 'react-intl';
import { handleLoginApi } from '../../services/userService';
import { isNullishCoalesce } from 'typescript';
import { userLoginSuccess } from '../../store/actions';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            isShowPassword: false,
            errMessage: "",
        }
    }
    handleOnChangeUsername = (event) => {
        this.setState({
            username: event.target.value,
        })
        // console.log(event.target.value)
    }
    handleOnChangePassword = (event) => {
        this.setState({
            password: event.target.value,
        })
        // console.log(event.target.value)
    }
    handleOnKeyPress = e => {
        if (e.key === 'Enter') {

            this.handleLogin();
        }
    }
    handleLogin = async () => {

        this.setState({
            errMessage: "",
        })

        try {
            let data = await handleLoginApi(this.state.username, this.state.password);

            if (data && data.errCode !== 0) {
                this.setState({
                    errMessage: data.message,
                })

            }
            if (data && data.errCode === 0) {

                this.props.userLoginSuccess(data.user); // Luu nguoi dung vao redux
                console.log("login success")
            }
        } catch (error) {
            // console.log(e);
            console.log('Mrkay:', error.response);
            if (error.response) {
                if (error.response.data) {
                    this.setState({
                        errMessage: error.response.data.message,
                    })
                }
            }


        }
        // alert('here');

    }
    handleShowHidePassword = () => {
        this.setState({
            isShowPassword: !this.state.isShowPassword,
        }

        )


    }
    render() {

        return (
            <div className='login-background'>
                <div className="login-container">
                    <div className="login-content row">
                        <div className='col-12 text-login'>ZOMZOM Staff</div>
                        <div className='col-12 form-group login-input'>
                            <label>Username: </label>
                            <input
                                type='text'
                                className="form-control"
                                placeholder="Enter your username"
                                value={this.state.username}
                                onChange={(event) => this.handleOnChangeUsername(event)}
                            />
                        </div>
                        <div className='col-12 form-group login-input'>
                            <div className="custom-imput-password">
                                <label>Password: </label>
                                <input
                                    type={this.state.isShowPassword ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Enter your password"
                                    value={this.state.password}
                                    onChange={(event) => this.handleOnChangePassword(event)}
                                    onKeyPress={this.handleOnKeyPress}
                                />
                                <span
                                    onClick={() => (this.handleShowHidePassword())}
                                ><i class={this.state.isShowPassword ? 'fas  fa-eye-slash' : 'fas fa-eye'}></i></span>

                            </div>
                        </div>
                        <div className="col-12">

                            {this.state.errMessage}
                        </div>
                        <div className="col-12">
                            <button className="btn-login"
                                onClick={() => (this.handleLogin())}
                            > Log in </button>
                        </div>

                        <div className='col-12'>
                            <span className="forgot-password">Forgot your password?</span>
                        </div>
                        <div className="col-12 text-center">
                            <span className=""> Or sign in with: </span>
                        </div>
                        <div className="col-12 social-login mt-3">
                            <i className="fab fa-google-plus-g google"></i>
                            <i className="fab fa-facebook-f facebook"></i>
                        </div>
                    </div>

                </div>

            </div>

        )
    }
}
// 2 ham redux
const mapStateToProps = state => {
    return {
        lang: state.app.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        navigate: (path) => dispatch(push(path)),

        userLoginFail: () => dispatch(actions.userLoginFail()),
        userLoginSuccess: () => dispatch(actions.userLoginSuccess()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
